export const Layout = {
  layout: {
    labelCol: { span: 4 },
    wrapperCol: { span: 8 },
  },
  tailLayout: {
    wrapperCol: { offset: 8, span: 16 },
  },
};
